import React, { useEffect } from 'react';

import VideoThumbTitleStyles from '../../ui/VideoThumbTitle';
import VideoThumbWrapperStyles from '../../ui/VideoThumbWrapper';
import VideoStyles from '../../ui/Video';
import VideoThumbStyles from '../../ui/VideoThumb';
import VideoPlayWrapperStyles from '../../ui/VideoPlayWrapper';
import VideoPlayButtonStyles from '../../ui/VideoPlayButton';
import VideoTotalTimeStyles from '../../ui/VideoTotalTime';

import Video from '../../../interfaces/video';
import { getOnboarding } from '../../../services/onboarding';

interface Props {
  video: Video;
}
const VideoComponent: React.FC<Props> = ({ video }: Props) => {
  /**
   * Verifica se após fechar o modal do vídeo
   * houve mudança no status da propriedade
   * wasWatched
   */
  const listenModal = (): void => {
    MdHub.event.add('core:moduleHide', module => {
      if (module.moduleName === 'platform.onboarding-modal') {
        getOnboarding();
      }
    });
  };

  const openModalVideo = (): void => {
    MdHub.command.send('platform.onboarding-modal', 'setVideoId', video.id);
    MdHub.command.send('platform.onboarding-modal', 'setPlatform', 'dispenser');
    MdHub.module.show('platform.onboarding-modal');
  };

  const convertSecondsInMinutes = (time: number): string => {
    if (time < 60) {
      return time.toString().replace('.', ':');
    }
    return (time / 60)
      .toPrecision(3)
      .toString()
      .replace('.', ':');
  };

  useEffect(listenModal, []);

  return (
    <VideoThumbWrapperStyles
      id={`${video.id}`}
      className="onboarding-video-card-thumbnail"
      onClick={(): void => {
        openModalVideo();
      }}
    >
      <VideoThumbStyles
        className={`card-video-${video.id}`}
        wasWatched={video.wasWatched}
      />
      <VideoPlayWrapperStyles
        id={video.id}
        className={video.wasWatched ? 'guides-container-play-button-checked' : 'guides-container-play-button'}
        wasWatched={video.wasWatched}
      >
        <VideoPlayButtonStyles
          className={video.wasWatched ? 'guides-video-play-button-checked' : 'guides-video-play-button'}
          wasWatched={video.wasWatched}
          image={
            video.wasWatched
              ? 'https://cdn.memed.com.br/icons-onboarding/PNG/check.png'
              : 'https://cdn.memed.com.br/icons-onboarding/PNG/play.png'
          }
        />
      </VideoPlayWrapperStyles>
      <VideoStyles className="thumb-video" thumbnail={video.thumbnail} />
      <VideoTotalTimeStyles>{convertSecondsInMinutes(video.total_time)}</VideoTotalTimeStyles>
      <VideoThumbTitleStyles>{video.title}</VideoThumbTitleStyles>
    </VideoThumbWrapperStyles>
  );
};

export default VideoComponent;
